import { IUserVerificationStatus } from "../models/IUserVerificationStatus";
import { getUserVerificationStatus } from "../services/auth";
import { getUserToken, isLoggedIn } from "./tokenUtils";

// Sayfa yenilenince sıfırlanır (module-level variable)
let cached: IUserVerificationStatus | null = null;

export const getVerificationCache = () => cached;

export const isProfileComplete = () => {
  if (!cached) return true; // henüz yüklenmedi — bloklamıyoruz
  return cached.emailVerified && cached.phoneVerified && cached.dateOfBirthExists && cached.isOver14;
};

/** Eğer cache yoksa API'den çek ve cache'e yaz */
export const fetchVerificationStatus = async (): Promise<IUserVerificationStatus | null> => {
  if (!isLoggedIn()) return null;
  if (cached) return cached;
  const token = getUserToken();
  if (!token) return null;
  try {
    const res = await getUserVerificationStatus(token.userId);
    cached = res.data;
    return cached;
  } catch {
    return null;
  }
};
